<template>
  <div class="not-found-page">
    <div class="nf-card">
      <div class="nf-code">404</div>
      <div class="nf-title">页面不存在</div>
      <div class="nf-path">未找到路径 <span>{{ $route.fullPath }}</span></div>
      <div class="nf-actions">
        <button class="nf-btn primary" @click="goHome">返回首页</button>
        <button class="nf-btn" @click="goBack">返回上一页</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goHome() {
      this.$router.replace("/entitylink");
    },
    goBack() {
      // 直接打开书签/外链进来时没有上一页，退回首页兜底
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.goHome();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.not-found-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 50% 30%, #16305c 0%, #0a1730 55%, #060e1f 100%);
}

.nf-card {
  min-width: 460px;
  padding: 56px 64px;
  border-radius: 12px;
  background: rgba(18, 38, 74, 0.78);
  border: 1px solid rgba(90, 150, 230, 0.28);
  box-shadow: 0 18px 48px rgba(0, 0, 0, 0.45);
  text-align: center;
}

.nf-code {
  font-size: 96px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 4px;
  color: #4d9bff;
  text-shadow: 0 0 28px rgba(77, 155, 255, 0.55);
}

.nf-title {
  margin-top: 16px;
  font-size: 22px;
  color: #e8f1ff;
}

.nf-path {
  margin-top: 12px;
  font-size: 13px;
  color: rgba(200, 220, 250, 0.62);
  word-break: break-all;

  span {
    color: #7fb6ff;
  }
}

.nf-actions {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  gap: 14px;
}

.nf-btn {
  min-width: 120px;
  height: 38px;
  padding: 0 20px;
  font-size: 14px;
  color: #cfe2ff;
  cursor: pointer;
  border-radius: 6px;
  background: transparent;
  border: 1px solid rgba(120, 170, 240, 0.45);
  transition: all 0.2s;

  &:hover {
    color: #ffffff;
    border-color: #4d9bff;
    background: rgba(77, 155, 255, 0.16);
  }

  &.primary {
    color: #ffffff;
    background: #1f6fd0;
    border-color: #1f6fd0;

    &:hover {
      background: #2b82ea;
      border-color: #2b82ea;
    }
  }
}

@media (max-width: 768px) {
  .nf-card {
    min-width: 0;
    width: 90%;
    padding: 40px 24px;
  }

  .nf-code {
    font-size: 72px;
  }
}
</style>
